import React, { useEffect, useState } from 'react';
import iconBack from '../../../images/icon-chevron-left.svg';
import styles from './AvailabilityConfirm.module.css';
import iconCheck from '../../../images/icon-round-check.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import { addAvailability, getConflictedAvailability } from '../../../redux/availability/actions/availability.action';
import { useSelector } from 'react-redux';
import Loader from '../../common/loader/Loader';
import TinyLoader from '../../common/tiny-loader/TinyLoader';
import ExistingAvailabilityTable from './existing-availability-table/ExistingAvailabilityTable';
import OfficeHoursTable from './office-hours/OfficeHoursTable';
import { weekdaysOrder } from '../../../constants/constants';
import CustModal from '../../common/custmodal/CustModal';
import AddUnits from '../../units/addunits/AddUnits';
import Toast from '../../common/toast/Toast';
import { getUnitById } from '../../../redux/units/actions/unitById.action';
import { Controller, useForm } from 'react-hook-form';
import TextInput from '../../common/input/textInput/TextInput';
import { assignLocker, removeAssignLocker } from '../../../redux/bms-locker/actions/bms-locker.action';
import toast from 'react-hot-toast';

export interface Slots {
    value: string;
    label: string;
}

export const getOpeningTime = (slots: Slots[]) => {
    let openingTime = '';
    openingTime = (Array.isArray(slots) && slots[0].value) || '';
    return openingTime;
};

export const getClosingTime = (slots: Slots[]) => {
    let closingTime = '';
    closingTime =
        (Array.isArray(slots) &&
            moment(slots[slots.length - 1].value, 'HH:mm')
                .add(1, 'hours')
                .format('HH:mm')) ||
        '';
    return closingTime;
};

interface FormData {
    reason: string;
}

const AvailabilityConfirm = () => {
    const { availabilityObject, type, locationId, unitId, unitName, nickName, locationName, lockerType, provisionId } = useLocation().state;
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    const [officeHours, setOfficeHours] = useState([]);
    const [openingTime, setOpeningTime] = useState('');
    const [closingTime, setClosingTime] = useState('');
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const loading = useSelector((state: IRootState) => state.availability.loading);
    const conflictedAvailabilityData = useSelector((state: IRootState) => state.availability.conflictedAvailability.data);
    const conflictedAvailabilityLoading = useSelector((state: IRootState) => state.availability.conflictedAvailability.loading);

    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState('');
    const [toastMessage, setToastMessage] = useState('');
    const locationData = useSelector((state: IRootState) => state.locationReducer.location.data);

    const unitByIdData = useSelector((state: IRootState) => state.unitById.data.unit);
    const unitByIdLoader = useSelector((state: IRootState) => state.unitById.loading);
    const [unitsData, setUnitsData] = useState(null);

    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false);
            }, 4000);
        }
    }, [showToast]);

    useEffect(() => {
        setUnitsData(unitByIdData || null);
    }, [unitByIdData]);

    const { control, watch } = useForm<FormData>();
    const reason = watch('reason');

    useEffect(() => {
        if (availabilityObject && Object.keys(availabilityObject).length) {
            const { locationId, locker, startDate, endDate, availabilitySlots } = availabilityObject;
            let openingTime, closingTime;

            if (Array.isArray(availabilitySlots)) {
                const [open, close] = [availabilitySlots[0]?.value, availabilitySlots[availabilitySlots.length - 1]?.value];
                openingTime = open;
                closingTime = moment(close, 'HH:mm').add(1, 'hours').format('HH:mm');
            } else {
                const [open, close] = availabilitySlots.split(' - ');
                openingTime = open;
                closingTime = close;
            }

            if (openingTime && closingTime) {
                const conflictedAvailabilityObj = {
                    locationId,
                    locker,
                    startDate: moment(startDate).format('YYYY-MM-DD'),
                    openingTime: moment(openingTime, 'hh:mm A').format('HH:mm'),
                    closingTime:
                        moment(closingTime, 'hh:mm A').format('HH:mm') === '00:00'
                            ? '23:59'
                            : moment(closingTime, 'hh:mm A').format('HH:mm'),
                    customAvailability: availabilityObject.satSunAvailability
                        ? [
                              {
                                  day: 'Saturday',
                                  openingTime: getOpeningTime(availabilityObject?.saturdaySlots),
                                  closingTime:
                                      getClosingTime(availabilityObject?.saturdaySlots) === '00:00'
                                          ? '23:59'
                                          : getClosingTime(availabilityObject?.saturdaySlots),
                                  isClosed: Boolean(!availabilityObject?.saturdaySlots?.length),
                              },
                              {
                                  day: 'Sunday',
                                  openingTime: getOpeningTime(availabilityObject?.sundaySlots),
                                  closingTime:
                                      getClosingTime(availabilityObject?.sundaySlots) === '00:00'
                                          ? '23:59'
                                          : getClosingTime(availabilityObject?.sundaySlots),
                                  isClosed: Boolean(!availabilityObject?.sundaySlots?.length),
                              },
                          ]
                        : [
                              {
                                  day: 'Saturday',
                                  openingTime: moment(openingTime, 'hh:mm A').format('HH:mm'),
                                  closingTime:
                                      moment(closingTime, 'hh:mm A').format('HH:mm') === '00:00'
                                          ? '23:59'
                                          : moment(closingTime, 'hh:mm A').format('HH:mm'),
                                  isClosed: false,
                              },
                              {
                                  day: 'Sunday',
                                  openingTime: moment(openingTime, 'hh:mm A').format('HH:mm'),
                                  closingTime:
                                      moment(closingTime, 'hh:mm A').format('HH:mm') === '00:00'
                                          ? '23:59'
                                          : moment(closingTime, 'hh:mm A').format('HH:mm'),
                                  isClosed: false,
                              },
                          ],
                };

                // dispatch(getConflictedAvailability(conflictedAvailabilityObj));
            }
        }
    }, [availabilityObject]);

    useEffect(() => {
        if (
            type === 'add-availability' &&
            availabilityObject &&
            Object.keys(availabilityObject).length &&
            availabilityObject.availabilitySlots
        ) {
            const openingTime = Array.isArray(availabilityObject.availabilitySlots)
                ? availabilityObject.availabilitySlots[0]?.value
                : availabilityObject.availabilitySlots.split('-')[0];

            const closingTime = Array.isArray(availabilityObject.availabilitySlots)
                ? moment(availabilityObject.availabilitySlots[availabilityObject.availabilitySlots.length - 1]?.value, 'HH:mm')
                      .add(1, 'hours')
                      .format('HH:mm')
                : availabilityObject.availabilitySlots.split('-')[1];

            setOpeningTime(moment(openingTime, 'hh:mm A').format('HH:mm'));
            setClosingTime(moment(closingTime, 'hh:mm A').format('HH:mm'));
        }
    }, [availabilityObject, type]);

    useEffect(() => {
        const result = availabilityObject?.officeHours.map(
            (data: { title: string; isOpen: number; openTime: string; closeTime: string; day: string }) => {
                const obj = {
                    title: data.day,
                    closed: data.isOpen === 0 ? true : false,
                    data: [{ slot: `${data.openTime} - ${data.closeTime}` }],
                };

                return obj;
            },
        );

        result &&
            !!result.length &&
            result.sort((a: { title: string }, b: { title: string }) => {
                return weekdaysOrder.indexOf(a.title) - weekdaysOrder.indexOf(b.title);
            });

        setOfficeHours(result);
    }, [availabilityObject]);

    const availabilitiesDetail = [
        {
            title: 'Property',
            value: availabilityObject?.locationName,
        },
        {
            title: 'Unit',
            value: availabilityObject?.unitName,
        },
        {
            title: 'Start Date',
            value: availabilityObject?.startDate,
        },
        {
            title: 'End Date',
            value: availabilityObject?.endDate,
        },
        {
            title: 'Locker No',
            value: availabilityObject?.locker,
        },
        {
            title: 'Buffer Hour',
            value: '1 hr',
        },
    ];

    const getMinStartTime = (openingTime: string) => {
        const startTimeArray = [moment(openingTime, 'hh:mm A').format('HH:mm')];

        const saturdayStartTime = getOpeningTime(availabilityObject?.saturdaySlots);
        const sundayStartTime = getOpeningTime(availabilityObject.sundaySlots);

        if (saturdayStartTime) {
            startTimeArray.push(saturdayStartTime);
        }

        if (sundayStartTime) {
            startTimeArray.push(sundayStartTime);
        }

        return startTimeArray.reduce((min, current) => {
            return current < min ? current : min;
        }, startTimeArray[0]);
    };

    const getMaxEndTime = (closingTime: string) => {
        const endTimeArray = [moment(closingTime, 'hh:mm A').format('HH:mm')];

        const saturdayEndTime = getClosingTime(availabilityObject?.saturdaySlots);
        const sundayEndTime = getClosingTime(availabilityObject.sundaySlots);

        if (saturdayEndTime) {
            endTimeArray.push(saturdayEndTime === '00:00' ? '23:59' : saturdayEndTime);
        }

        if (sundayEndTime) {
            endTimeArray.push(sundayEndTime === '00:00' ? '23:59' : sundayEndTime);
        }

        return endTimeArray.reduce((max, current) => {
            return current > max ? current : max;
        }, endTimeArray[0]);
    };

    const addAvailabilityHandler = async () => {
        // setConfirmLoading(true);

        let availabilitySlots;

        if (typeof availabilityObject.availabilitySlots === 'string') {
            try {
                availabilitySlots = JSON.parse(availabilityObject.availabilitySlots);
            } catch (error) {
                availabilitySlots = [];
            }
        } else {
            availabilitySlots = availabilityObject.availabilitySlots;
        }

        const formatTo24Hour = (time12h: string) => {
            return moment(time12h, 'hh:mm A').format('HH:mm');
        };

        const getTimeSlots = (slots: any[]) => {
            return slots.map((slot) => {
                const openingTime = formatTo24Hour(slot.startTime);
                let closingTime = formatTo24Hour(slot.endTime);
                if (closingTime === '00:00') {
                    closingTime = '23:59';
                }
                return { openingTime, closingTime };
            });
        };

        const defaultTimeSlots = availabilitySlots?.length
            ? availabilitySlots.map((slot: { startTime: string; endTime: string }) => ({
                  openingTime: formatTo24Hour(slot.startTime),
                  closingTime: formatTo24Hour(slot.endTime) === '00:00' ? '23:59' : formatTo24Hour(slot.endTime),
              }))
            : [];

        const saturdaySlots = availabilityObject?.saturdaySlots || [];
        const sundaySlots = availabilityObject?.sundaySlots || [];

        const customAvailability = [
            {
                day: 'Saturday',
                timeSlots: availabilityObject.satSunAvailability ? getTimeSlots(saturdaySlots) : defaultTimeSlots,
                isClosed: availabilityObject.satSunAvailability ? !saturdaySlots.length : false,
            },
            {
                day: 'Sunday',
                timeSlots: availabilityObject.satSunAvailability ? getTimeSlots(sundaySlots) : defaultTimeSlots,
                isClosed: availabilityObject.satSunAvailability ? !sundaySlots.length : false,
            },
        ];

        const addAvailabilityObj = {
            locationId: availabilityObject.locationId,
            unitId: availabilityObject.unitId,
            locker: availabilityObject.locker,
            startDate: moment(availabilityObject.startDate).format('YYYY-MM-DD'),
            timeSlots: defaultTimeSlots,
            isVisitorTab: false,
            customAvailability,
        };

        const lockerType = locationData?.location?.lockerTypeLockerName;
        const provisioniId = locationData?.location?.provisioningId;

        try {
            if (lockerType?.toLowerCase() === 'bms' && unitId) {
                setConfirmLoading(true);
                const assign = assignLocker(provisioniId, unitId);
                const { message, error, locker } = await assign();

                if (!error) {
                    const availabilityObject = { ...addAvailabilityObj, locker: locker };
                    dispatch(addAvailability(availabilityObject, undefined, navigate, undefined, setConfirmLoading));
                } else {
                    setConfirmLoading(false);
                    setShowToast(true);
                    setToastMessage(message);
                }
            }

            if (lockerType?.toLowerCase() !== 'bms') {
                dispatch(addAvailability(addAvailabilityObj, undefined, navigate, undefined, setConfirmLoading));
            }
        } catch (err) {
            console.error('Error in Add Availability Handler:', err);
            setShowToast(true);
            setToastMessage('Something went wrong while adding availability.');
        }
    };

    const onRemoveLockerFailure = async (message: string) => {
        setShowToast(true);
        setToastMessage(message);
        setToastType('error');
        setConfirmLoading(false);
    };

    const onRemoveLockerSuccess = async () => {
        setConfirmLoading(false);
        toast.success('Unit Unavailable Successfully.');
        navigate('/visits');
    };

    const makeUnitUnavailableHandler = async () => {
        if (lockerType?.toLowerCase() === 'bms' && provisionId) {
            setConfirmLoading(true);
            await axios
                .delete(`/admin/availabilities/delete-Unit-availabilites/${unitId}`, {
                    data: { reason: reason },
                })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        dispatch(removeAssignLocker(provisionId, unitId, onRemoveLockerSuccess, onRemoveLockerFailure));
                        // dispatch(removeAssignLocker(84584102, unitId, onRemoveLockerSuccess, onRemoveLockerFailure));
                    }
                })
                .catch(() => {
                    setConfirmLoading(false);
                    setToastMessage('Something went wrong while making unit unavailable.');
                    setShowToast(true);
                    setToastType('error');
                });
        } else if (lockerType?.toLowerCase() === 'bms' && !provisionId) {
            setConfirmLoading(false);
            setToastMessage('Provision id missing');
            setShowToast(true);
            setToastType('error');
        } else {
            setConfirmLoading(true);
            axios
                .delete(`/admin/availabilities/delete-Unit-availabilites/${unitId}`, {
                    data: { reason: reason },
                })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        setConfirmLoading(false);
                        toast.success('Unit Unavailable Successfully.');
                        navigate('/visits');
                    }
                })
                .catch(() => {
                    setConfirmLoading(false);
                    setToastMessage('Something went wrong while making unit unavailable.');
                    setShowToast(true);
                    setToastType('error');
                });
        }
    };

    const backNavigationHandler = () => {
        const provisionId = locationData?.location?.provisioningId;
        type === 'add-availability'
            ? navigate('/add-availability/booking', { state: { type, locationId, unitId, provisionId, locationName } })
            : navigate('/add-availability/units', { state: { type, locationId, unitId, provisionId, locationName } });
    };

    const onEditButton = async () => {
        await dispatch(getUnitById(unitId));
        setShowEditModal(true);
    };

    return (
        <>
            {loading || confirmLoading ? (
                <Loader />
            ) : (
                <div className="outletConainer">
                    <div className={styles.inlineItems}>
                        <div className={styles.leftSection}>
                            <div onClick={backNavigationHandler} className={styles.backButton}>
                                <img src={iconBack} alt="back icon" />
                            </div>

                            <h2>{`${type === 'make-unit-unavailable' ? 'Make Unit Unavailable' : 'Add Availability'}`}</h2>
                        </div>

                        <div className={styles.rightContainer}>
                            <button
                                className={styles.editBtn}
                                onClick={() => {
                                    onEditButton();
                                }}>
                                Edit Unit
                            </button>
                            <button
                                onClick={type === 'add-availability' ? addAvailabilityHandler : makeUnitUnavailableHandler}
                                className={styles.confirmButton}
                                disabled={type === 'add-availability' ? false : reason === null || reason?.trim() === '' ? true : false}>
                                Confirm
                            </button>
                        </div>
                    </div>

                    <div className={styles.availabilityContainer}>
                        {type === 'add-availability' ? (
                            <>
                                <div className={styles.availabilitiesDetailContainer}>
                                    {availabilitiesDetail
                                        ?.filter(
                                            (item) =>
                                                !(
                                                    locationData?.location?.lockerTypeLockerName?.toLowerCase() === 'bms' &&
                                                    item.title === 'Locker No'
                                                ),
                                        )
                                        .map((value: any, index: number) => {
                                            return (
                                                <div className={styles.detailContainer} key={index}>
                                                    <p className={styles.header}>{value?.title}</p>
                                                    <p className={styles.value}>{value?.value}</p>
                                                </div>
                                            );
                                        })}
                                </div>
                                <div className={styles.appointmentMessage}>
                                    <p>
                                        *Any appointment made will have a one-hour buffer before and after. This allows visitors to pickup
                                        their keys up to 15 minutes and return their keys up to 45 minutes after their appointment time
                                        without conflict
                                    </p>
                                </div>

                                <OfficeHoursTable
                                    availabilityObject={availabilityObject}
                                    officeHours={officeHours}
                                    // closingTime={closingTime}
                                    // openingTime={openingTime}
                                    // saturdayOpeningTime={Array.isArray(availabilityObject.saturdaySlots) ? availabilityObject?.saturdaySlots[0]?.value : ''}
                                    // sundayOpeningTime={Array.isArray(availabilityObject.sundaySlots) ? availabilityObject?.sundaySlots[0]?.value : ''}
                                    // saturdayClosingTime={Array.isArray(availabilityObject?.saturdaySlots) ? moment(availabilityObject?.saturdaySlots[availabilityObject?.saturdaySlots.length - 1]?.value, 'HH:mm')
                                    //     .add(2, 'hours')
                                    //     .format('HH:mm') : ''}
                                    // sundayClosingTime={Array.isArray(availabilityObject?.sundaySlots) ? moment(availabilityObject?.sundaySlots[availabilityObject?.sundaySlots.length - 1]?.value, 'HH:mm')
                                    //     .add(2, 'hours')
                                    //     .format('HH:mm') : ''}
                                />
                            </>
                        ) : (
                            <div className={styles.makeUnitUnavailableSection}>
                                <h3>{`Remove all availability for "${unitName} ${nickName || ''} at ${locationName || ''}".`}</h3>
                                <h4>Confirm you would like to remove all availability for this unit.</h4>

                                <Controller
                                    name="reason"
                                    control={control}
                                    defaultValue=""
                                    rules={{ required: 'Reason is required' }}
                                    render={({ field }) => (
                                        <TextInput
                                            {...field}
                                            id="reason"
                                            className={styles.textarea}
                                            placeholder="Enter reason for unavailability"
                                        />
                                    )}
                                />
                            </div>
                        )}

                        {/* {type === 'add-availability' && conflictedAvailabilityData && !!conflictedAvailabilityData.length && (
                            <div className={styles.conflictedAvailability}>
                                <div className={styles.header}>
                                    <h2 className={styles.title}>Existing Availability to be deleted</h2>
                                </div>

                                <div className={styles.body}>
                                    <div className={styles.tableWrapper}>
                                        {conflictedAvailabilityLoading ? (
                                            <TinyLoader />
                                        ) : (
                                            <ExistingAvailabilityTable conflictedAvailabilityData={conflictedAvailabilityData} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )} */}
                    </div>
                </div>
            )}
            <CustModal
                open={showEditModal}
                setOpen={setShowEditModal}
                bodyData={
                    <AddUnits
                        isLoading={unitByIdLoader}
                        setShowToast={setShowToast}
                        setToastMessage={setToastMessage}
                        setOpen={setShowEditModal}
                        locationId={locationId}
                        unitData={unitsData}
                        unitsData={unitsData}
                        setUnitsData={setUnitsData}
                        setToastType={setToastType}
                    />
                }
            />

            {showToast && <Toast type={toastType || 'error'} message={toastMessage || ''} />}
        </>
    );
};

export default AvailabilityConfirm;
